import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

/**
 * Starea de blocare temporară a secțiunii „Autorizări Comerciale”.
 *
 * Sursa este AUTCOM Core: GET {basePath}app-locked
 *   { "errors": false, "data": { "locked": false }, "status_code": 200 }
 *
 * Dacă apelul eșuează, secțiunea rămâne accesibilă (fail-open), ca o indisponibilitate
 * a API-ului să nu blocheze depunerile.
 */
@Injectable({ providedIn: 'root' })
export class AutcomAppLockService {
    private readonly appLockedUrl =
        environment.interop.autcomCore.basePath +
        environment.interop.autcomCore.api.public.appLocked;

    /** Cache scurt, ca navigarea între pași să nu declanșeze un request per rută. */
    private readonly cacheTtlMs = 60_000;
    private cachedAt = 0;
    private cached$: Observable<boolean> | null = null;

    constructor(private http: HttpClient) { }

    isLocked(): Observable<boolean> {
        const now = Date.now();

        if (!this.cached$ || now - this.cachedAt > this.cacheTtlMs) {
            this.cachedAt = now;
            this.cached$ = this.http
                .get<{ data?: { locked?: boolean } }>(this.appLockedUrl)
                .pipe(
                    map((res) => res?.data?.locked === true),
                    catchError(() => of(false)),
                    shareReplay({ bufferSize: 1, refCount: false })
                );
        }

        return this.cached$;
    }

    /** Invalidează cache-ul (folosit la reîncercarea din pagina de indisponibilitate). */
    clearCache(): void {
        this.cached$ = null;
        this.cachedAt = 0;
    }
}
